const VERSION: string = '0.1.0-dev.21826';
export default VERSION;
